// css =>
import "../../BaseStructure.css";
import Styled from "./ShowProducts.module.css";

// componenets =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import SpinnerBar from "../../Components/spinnerBar/spinnerBar.comp";
import Product_Displayer from "../../Components/showProduct/showProduct.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";
import MobileSubMenu from "../../Components/mobileSubMenu/mobileSubMenu.comp";
import PagePagination from "../../Components/pagePagination/pagePagination.comp";

// pic =>
import NotImage from "../../Assets/Pictures/No_Image.png";

// icons =>
import OrangeDownFlashIcon from "../../Assets/Icons/orange-down-flash.png";

// react =>
import { useRef } from "react";
import { useState, useEffect, JSX } from "react";

// API =>
import backEnd from "../../services/Api";

// Type =>
import { PRODUCTS_RESPONSE, CATEGORY_TYPE } from "./ShowProductType";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function ShowProducts() {

    const pageSize = 20;
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [numberOfProducts, setNumberOfProducts] = useState<number>(0);

    const { showMessage } = useMessage();

    const filterBoxRef = useRef<HTMLDivElement | null>(null);
    const categoryFilterRef = useRef<HTMLDivElement | null>(null);
    const mobileFilterBoxRef = useRef<HTMLDivElement | null>(null);
    const mobileCategoryFilterRef = useRef<HTMLDivElement | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [categoryList, setCategoryList] = useState<CATEGORY_TYPE[]>();
    const [filteredUrl, setFilteredUrl] = useState<string>("&gender=MRS");
    const [allCategories, setAllCategories] = useState<CATEGORY_TYPE[]>([]);
    const [productList, setProductList] = useState<PRODUCTS_RESPONSE | null>(null);
    const [selectedGenderFilter, setSelectedGenderFilter] = useState<"MR" | "MRS" | "">("MRS");

    useEffect(() => {
        document.title = "نمایش محصولات | ویدوک";
        
        backEnd.get("products/get-category-list/").then(( result ) => {
            setAllCategories(result.data);
            // setCategoryList(result.data);
            setCategoryList(result.data.filter((cat: { gender: string }) => cat.gender === selectedGenderFilter));

            setIsLoading(false);
        }).catch(( error ) => {
            let message = "خطای غیرمنتظره‌ای رخ داد!";

            if (error.response) {
                const status = error.response.status;

                switch (status) {
                    case 404:
                        message = "محصولی یافت نشد!";
                        break;

                    case 500:
                        message = "مشکلی در سرور رخ داده، لطفاً لحظاتی بعد دوباره تلاش کنید.";
                        break;

                    default:
                        message = error.response.data?.detail || message;
                }
            } else if (error.request) {
                message = "ارتباط با سرور برقرار نشد. اینترنت خود را بررسی کنید.";
            } else {
                message = "در ارسال درخواست مشکلی به وجود آمد.";
            }

            setIsLoading(false);
            showMessage("error", message);
        })
    }, []);

    useEffect(() => {
        document.title = "نمایش محصولات | ویدوک";

        setIsLoading(true);
        backEnd.get(`products/get-products-list?page=${ currentPage }${ filteredUrl }`).then((result) => {
            setNumberOfProducts(result.data.count);
            setProductList(result.data);

            setIsLoading(false);
        }).catch(( error ) => {
            let message = "خطای غیرمنتظره‌ای رخ داد!";

            if (error.response) {
                const status = error.response.status;

                switch (status) {
                    case 404:
                        message = "محصولی یافت نشد!";
                        break;

                    case 500:
                        message = "مشکلی در سرور رخ داده، لطفاً لحظاتی بعد دوباره تلاش کنید.";
                        break;

                    default:
                        message = error.response.data?.detail || message;
                }
            } else if (error.request) {
                message = "ارتباط با سرور برقرار نشد. اینترنت خود را بررسی کنید.";
            } else {
                message = "در ارسال درخواست مشکلی به وجود آمد.";
            }

            setIsLoading(false);
            showMessage("error", message);
        });
    }, [filteredUrl, currentPage]);

    const handleProductFilter = (newFilterParam: string) => {
        setCurrentPage(1);
        setFilteredUrl(newFilterParam);
    };

    const handleOpenDesktopCategoryFilterSubMenu = () => {
        if (categoryFilterRef.current) {
            categoryFilterRef.current.style.display = 'block';
        }
    };
    
    const handleCloesDesktopCategoryFilterSubMenu = () => {
        if (categoryFilterRef.current) {
            categoryFilterRef.current.style.display = 'none';
        }
    };

    const handleOpenDesktopFilterBoxSubMenu = () => {
        if (filterBoxRef.current) {
            filterBoxRef.current.style.display = 'block';
        }
    };

    const handleCloesDesktopFilterBoxSubMenu = () => {
        if (filterBoxRef.current) {
            filterBoxRef.current.style.display = 'none';
        }
    };

    const handleOpenMobileCategoryFilterSubMenu = () => {
        if (mobileCategoryFilterRef.current) {
            if (mobileCategoryFilterRef.current.style.display === "none") {
                mobileCategoryFilterRef.current.style.display = "flex";
            } else {
                mobileCategoryFilterRef.current.style.display = "none";
            }
        }
    };

    const handleOpenMobileFilterBoxSubMenu = () => {
        if (mobileFilterBoxRef.current) {
            if (mobileFilterBoxRef.current.style.display === "none") {
                mobileFilterBoxRef.current.style.display = "flex";
            } else {
                mobileFilterBoxRef.current.style.display = "none";
            }
        }
    };

    const handleChnageProductFilterByGender = (selectedGender: "MR" | "MRS") => {
        setCurrentPage(1);
        setFilteredUrl(`&gender=${ selectedGender }`);

        setSelectedGenderFilter(selectedGender);
        setCategoryList(allCategories.filter(cat => cat.gender === selectedGender));
    }

    return (
        <>
            <MobileMenuBar key={ 0 } isAuthenticated />
            <Header />

            <div className="row">
                <div className="row" id={ Styled.DesktopProductsMenu }>
                    <div className={`col-3 ${ Styled.ProductsRightFrame } `}>
                        <div className="col-5" style={{ backgroundColor: selectedGenderFilter === "MR" ? "rgb(46, 117, 153)" : "" }} 
                            onClick={() => { handleChnageProductFilterByGender("MR")} }>
                            <h3 style={{ color: selectedGenderFilter === "MR" ? "white" : "" }}>مردانه</h3>
                        </div>
                        <div className="col-5" style={{ backgroundColor: selectedGenderFilter === "MRS" ? "rgb(153, 31, 92)" : "" }} 
                            onClick={() => { handleChnageProductFilterByGender("MRS")} }>
                            <h3 style={{ color: selectedGenderFilter === "MRS" ? "white" : "" }}>زنانه</h3>
                        </div>
                    </div>

                    <div className={`col-6 ${ Styled.ProductsMidFrame }`}>
                        <div className="col-3"
                            onMouseEnter={ handleOpenDesktopFilterBoxSubMenu }
                            onMouseLeave={ handleCloesDesktopFilterBoxSubMenu }>
                            <h3>فیلتر</h3>
                        </div>

                        <div className="col-3">
                            <h2>محصولات</h2>
                        </div>

                        <div className="col-3"
                            onMouseEnter={ handleOpenDesktopCategoryFilterSubMenu }
                            onMouseLeave={ handleCloesDesktopCategoryFilterSubMenu }>
                            <h3>دسته بندی</h3>
                        </div>
                    </div>

                    <div className={`col-3 ${ Styled.ProductsLeftFrame } `}>
                        <p>نمایش { numberOfProducts } محصول</p>
                    </div>
                </div>
            </div>

            <div ref={ categoryFilterRef } className={Styled.dropdown}
                onMouseEnter={ handleOpenDesktopCategoryFilterSubMenu }
                onMouseLeave={ handleCloesDesktopCategoryFilterSubMenu }>
                <div className={` row ${ Styled.menu } `}>
                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>

                    <div className={` col-8 ${ Styled.item } `}>
                        همه ی محصولات
                    </div>

                    {
                        categoryList?.length === 0 ? (
                                <p className="EmptyText">هنوز دسته بندی ثبت نشده است!</p>
                            ) : (
                                categoryList?.map((category) => (
                                    <>
                                        <div className={`col-1 ${ Styled.CheckBox } `} onClick={() => {
                                            setCurrentPage(1);
                                            setFilteredUrl(`&category=${ category?.id }`);
                                        }}>
                                            <div className="col-1"></div>
                                        </div>

                                        <div className={` col-8 ${ Styled.item } `} onClick={() => {
                                            setCurrentPage(1);
                                            setFilteredUrl(`&category=${ category?.id }`);
                                        }}>
                                            { category.full_name }
                                        </div>
                                    </>
                                ))
                            )
                    }
                </div>
            </div>

            <div ref={ filterBoxRef } className={ Styled.dropdown } style={{ marginLeft: '26%' }}
                onMouseEnter={ handleOpenDesktopFilterBoxSubMenu }
                onMouseLeave={ handleCloesDesktopFilterBoxSubMenu }>
                <div className={` row ${ Styled.menu } `}>
                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        handleProductFilter("");
                        setSelectedGenderFilter("");
                    }}>
                        بدون فیلتر
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        handleProductFilter("&ordering=-price");
                    }}>
                        گران ترین
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        handleProductFilter("&ordering=price");
                    }}>
                        ارزان ترین
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        handleProductFilter("&ordering=-newest");
                    }}>
                        جدید ترین
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        handleProductFilter("&ordering=-popularity");
                    }}>
                        محبوب ترین
                    </div>
                </div>
            </div>

            <div className="row" id={ Styled.ProductsShowInfoFrame }>
                <br />

                <div className="col-4">
                    <p>همه ی محصولات</p>
                </div>

                <div className="col-4">
                    <h3>نمایش { numberOfProducts } محصول</h3>
                </div>

                <div className="col-4">
                    <p>جدید ترین ها</p>
                </div>
            </div>

            <div className="row" id={ Styled.MobileProductsMenu }>
                <h1>محصولات</h1>

                <div ref={ mobileFilterBoxRef } className="col-3" onClick={ handleOpenMobileFilterBoxSubMenu }>
                    <img src={ OrangeDownFlashIcon } alt="Flash" />
                    <h3>دسته بندی</h3>
                </div>

                <div className="col-6" id={ Styled.MobileMenuMidlleSection }>
                    <div className="col-6"
                        style={{ backgroundColor: selectedGenderFilter === "MR" ? "rgb(46, 117, 153)" : "" }}
                        onClick={() => {
                            handleChnageProductFilterByGender("MR");
                        }}>
                        <h3>مردانه</h3>
                    </div>
                    <div className="col-6"
                        style={{ backgroundColor: selectedGenderFilter === "MRS" ? "rgb(153, 31, 92)" : "" }}
                        onClick={() => {
                            handleChnageProductFilterByGender("MRS");
                        }}>
                        <h3>زنانه</h3>
                    </div>
                </div>

                <div className="col-3" onClick={ handleOpenMobileCategoryFilterSubMenu }>
                    <img src={ OrangeDownFlashIcon } alt="Flash" />
                    <h3>فیلتر</h3>
                </div>
            </div>

            <div ref={ mobileFilterBoxRef } className={`row ${ Styled.CategorySubMenuFrame } `}>
                <MobileSubMenu
                    key={ 0 }
                    subMenuOptions={(categoryList?.map(cat => cat.full_name) || [])}
                    sunMenuWidthByPixel={ 120 }
                    onItemClick={(item, index) => {
                        if (index > 0) {
                            const selectedCategory = categoryList![index - 1];
                            let newFilter = filteredUrl + `&category=${ selectedCategory.id }`;
                            setFilteredUrl(newFilter);
                        }
                    }}
                />
            </div>

            <div ref={ mobileCategoryFilterRef } className={`row ${ Styled.FilterSubMenuFrame } `}>
                <MobileSubMenu
                    key={ 0 }
                    subMenuOptions={["بدون فیلتر", "گران ترین", "ارزان ترین", "جدید ترین", "محبوب ترین"]}
                    sunMenuWidthByPixel={ 120 }
                    onItemClick={(item) => {
                        switch (item) {
                            case "بدون فیلتر":
                                setFilteredUrl("");
                                setSelectedGenderFilter("");
                                break;

                            case "گران ترین":
                                handleProductFilter("&ordering=-price");
                                break;

                            case "ارزان ترین":
                                handleProductFilter("&ordering=price");
                                break;

                            case "جدید ترین":
                                handleProductFilter("&ordering=-newest");
                                break;

                            case "محبوب ترین":
                                handleProductFilter("&ordering=-popularity");
                                break;
                        }
                    }}
                />
            </div>

            <div className="row" id={ Styled.ProductsBoxFrame }>
                {
                    isLoading ? (
                        <div className="row">
                            <div className="col-12 SpinnerBarFrame">
                                <SpinnerBar />
                            </div>
                        </div>
                    ) : productList?.results.length === 0 ? (
                        <p className="EmptyText">هنوز محصولی ثبت نشده است!</p>
                    ) : (
                        productList?.results.map(item => (
                            <Product_Displayer 
                                key={ item.id }
                                productId={ item.id }
                                productName={ item.full_name }
                                productThumbnail={ item.thumbnail || NotImage }
                                productPrice={ item.price }
                                productColorList={ item.color }
                            />
                        ))
                    )
                }
            </div>

            <div className="row" id={Styled.PagePaginationFrame}>
                <PagePagination
                    currentPage={ currentPage }
                    totalCount={ numberOfProducts }
                    pageSize={ pageSize }
                    onPageChange={(page) => setCurrentPage(page)}
                />
            </div>

            <br /><br /><br />

            <MenuBar />
        </>
    );
}

export default ShowProducts;
